import { styles } from "@repo/helpers";

import "./style.scss";
import { Props } from "./types";

export function Col(props: Props) {
	const { auto, lg, md, sm, xs, fit, children, tag = "div", ...rest } = props;
	const Tag = tag;
	function getColClass() {
		if (auto) return "col-auto";
		if (lg) return "col-lg-" + lg;
		if (md) return "col-md-" + md;
		if (sm) return "col-sm-" + sm;
		if (xs) return "col-" + xs;
		return "col";
	}

	const className = styles(props.className, getColClass(), fit && "fitContent");

	return (
		<Tag {...rest} className={className}>
			{children}
		</Tag>
	);
}

export default Col;
